<template>
  <div class="mt-3" style="font-size: 80%">
    <div class="accordion mb-2" id="accordionPrecioHora">
      <div class="shadow">
        <button
          class="btn btn-success btn-sm w-100"
          @click="buttonNuevo()"
          type="button"
          data-toggle="collapse"
          data-target="#collapsePrecioHora"
          aria-expanded="false"
          aria-controls="collapsePrecioHora"
        >
          <i class="fas fa-plus-circle"></i>
          Nueva Categoría de Precios
        </button>

        <div
          id="collapsePrecioHora"
          class="collapse"
          aria-labelledby="headingPrecioHora"
          data-parent="#accordionPrecioHora"
        >
          <div class="w-100 card-body shadow rounded bg-light">
            <b-form @submit.prevent="procesarFormulario">
              <div class="container">
                <div class="form-row mb-3">
                  <div class="col-md-12">
                    <label for="nombre" class="form-label font-weight-bold">Nombre de la Categoría/Sector</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="form.nombre"
                      id="nombre"
                      required
                      placeholder="Ej: Seguridad, Auditoría, etc."
                    ></b-form-input>
                  </div>
                </div>

                <div class="form-row mb-3">
                  <div class="col-3">
                    <label class="form-label">Tarifa Principal</label>
                    <b-form-input type="number" step="0.01" size="sm" v-model="form.tarifaPrincipal" required></b-form-input>
                  </div>
                  <div class="col-3">
                    <label class="form-label">Tarifa Senior</label>
                    <b-form-input type="number" step="0.01" size="sm" v-model="form.tarifaSenior" required></b-form-input>
                  </div>
                  <div class="col-3">
                    <label class="form-label">Tarifa Junior</label>
                    <b-form-input type="number" step="0.01" size="sm" v-model="form.tarifaJunior" required></b-form-input>
                  </div>
                  <div class="col-3">
                    <label class="form-label">Tarifa Delineante</label>
                    <b-form-input type="number" step="0.01" size="sm" v-model="form.tarifaDelineante" required></b-form-input>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  class="mr-2"
                  data-toggle="collapse"
                  data-target="#collapsePrecioHora"
                  @click="resetForm()"
                  ><i class="far fa-times-circle mr-1"></i>Cancelar</b-button
                >
                <b-button
                  variant="primary"
                  size="sm"
                  type="submit"
                  data-toggle="collapse"
                  data-target="#collapsePrecioHora"
                  ><i class="far fa-check-circle mr-1"></i>{{ editando ? 'Actualizar' : 'Guardar' }}</b-button
                >
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-3">
      <b-table
        responsive
        head-variant="light"
        :fields="camposTabla"
        :items="items"
        small
        hover
      >
        <template #cell(accion)="row">
          <b-button-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              data-toggle="collapse"
              data-target="#collapsePrecioHora"
              @click="buttonEditar(row.item)"
              class="mr-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="outline-danger"
              @click="eliminar(row.item)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "PrecioHoraCategoriaSectorComponent",
  data() {
    return {
      editando: false,
      form: {
        id: null,
        nombre: "",
        tarifaPrincipal: 0,
        tarifaSenior: 0,
        tarifaJunior: 0,
        tarifaDelineante: 0
      },
      camposTabla: [
        { key: "nombre", label: "Nombre", sortable: true },
        { key: "tarifaPrincipal", label: "Principal", sortable: true },
        { key: "tarifaSenior", label: "Senior", sortable: true },
        { key: "tarifaJunior", label: "Junior", sortable: true },
        { key: "tarifaDelineante", label: "Delineante", sortable: true },
        { key: "accion", label: "", thStyle: { width: "100px" } },
      ],
      items: [],
    };
  },
  methods: {
    async obtenerItems() {
      try {
        const { data } = await api1.get("/api/dekra-projects/v204/precio-hora-categoria-sector");
        this.items = data;
      } catch (error) {
        console.error("Error obteniendo categorías de precios:", error);
      }
    },
    procesarFormulario() {
      if (this.editando) {
        this.actualizar();
      } else {
        this.guardar();
      }
    },
    async guardar() {
      try {
        await api1.post("/api/dekra-projects/v204/precio-hora-categoria-sector", this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al guardar:", error);
      }
    },
    async actualizar() {
      try {
        await api1.put(`/api/dekra-projects/v204/precio-hora-categoria-sector/${this.form.id}`, this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al actualizar:", error);
      }
    },
    async eliminar(item) {
      if (!confirm("¿Seguro que quieres borrar esta categoría de precios?")) return;
      try {
        await api1.delete(`/api/dekra-projects/v204/precio-hora-categoria-sector/${item.id}`);
        this.obtenerItems();
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    },
    buttonNuevo() {
      this.editando = false;
      this.resetForm();
    },
    buttonEditar(item) {
      this.editando = true;
      this.form = { ...item };
    },
    resetForm() {
      this.form = {
        id: null,
        nombre: "",
        tarifaPrincipal: 0,
        tarifaSenior: 0,
        tarifaJunior: 0,
        tarifaDelineante: 0
      };
    }
  },
  mounted() {
    this.obtenerItems();
  }
};
</script>
